<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title style="padding-left:8px;padding-bottom:8px">
        <span class="headline mb-0">邮件监控</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search">search</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <v-select :items="[-1,0,1]" clearable label="状态" v-model="query.status"></v-select>
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="邮件标题" v-model="query.mailSubject" />
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="邮件内容" v-model="query.mailBody" />
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="to地址" v-model="query.toAddress" />
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="cc地址" v-model="query.ccAddress" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :max="query.createDateTo"
                    label="创建时间起止"
                    v-model="query.createDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker :min="query.createDateFrom" label="~" v-model="query.createDateTo"></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :max="query.updateDateTo"
                    label="更新时间起止"
                    v-model="query.updateDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker :min="query.updateDateFrom" label="~" v-model="query.updateDateTo"></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected[pagination.page]"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.createTime }}</td>
          <td>{{ props.item.updateTime }}</td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.mailSubject }}</td>
          <td>{{ props.item.toAddress }}</td>
          <td>{{ props.item.ccAddress }}</td>
          <td>{{ props.item.retryTimes }}</td>
          <td @click="showContent(props.item.mailBody)">{{ props.item.mailBody }}</td>
          <td>{{ props.item.mailError }}</td>
          <td>
            <v-btn @click="resetStatus(props.item.id)">重置状态</v-btn>
          </td>
        </template>
      </v-data-table>
      <mail-body ref="mailBody"></mail-body>
    </v-card>
  </v-container>
</template>
<script>
import MailBody from './MailBody'
export default {
  components: { MailBody },
  data() {
    return {
      selected: [],
      results: [],
      pagination: {
        rowsPerPage: 10
      },
      loading: false,
      query: {},
      headers: [
        {
          text: '创建时间',
          value: 'createTime',
          sortable: false
        },
        {
          text: '更新时间',
          value: 'updateTime',
          sortable: false
        },
        {
          text: '状态',
          value: 'status',
          sortable: false
        },
        {
          text: '邮件标题',
          value: 'mailSubject',
          sortable: false
        },
        {
          text: 'To地址',
          value: 'toAddress',
          sortable: false
        },
        {
          text: 'CC地址',
          value: 'ccAddress',
          sortable: false
        },
        {
          text: '重试次数',
          value: 'retryTimes',
          sortable: false
        },
        {
          text: '邮件内容',
          value: 'mailBody',
          sortable: false
        },
        {
          text: 'Error',
          value: 'mailError',
          sortable: false
        },
        {
          text: '操作',
          value: 'operation',
          sortable: false
        }
      ]
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: 'createTime,desc'
        }
      }
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/mail', this.params()).then(res => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    showContent(body) {
      this.$refs.mailBody.popup(body)
    },
    resetStatus(id) {
      this.$http
        .put(`mail/reset-status/${id}`)
        .then(() => {
          this.$message('', '重置成功')
        })
        .catch(() => {
          this.$message('', '重置失败')
        })
    }
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  }
}
</script>
